import { useHiddenCategories } from "../../api/hiddenCategories";

// Renders its children only while none of the given category slugs/names have
// been hidden from the admin panel. Used to drop whole home-page sections.
export default function CategoryGate({ slugs, children }) {
  const { isCategoryHidden } = useHiddenCategories();
  return isCategoryHidden(...slugs) ? null : children;
}
